module.exports = __webpack_public_path__ + "img/hr-level2addon_dead_mask.c7cec004.png";